<section class="Offers">
  <div class="experts-big-text">
    <p>
      <span class="highlight">{{ "offers.header.highlight" | translate }}</span
      >{{ "offers.header.title" | translate }}<br class="mob-br" />
      <span class="captional-text">{{ "offers.header.bold" | translate }}</span>
    </p>
  </div>
  <div class="experts-text">
    <p>
      <span class="rectangle"></span>{{ "offers.header.text1" | translate }}
    </p>
    <p>
      <span class="rectangle"></span>{{ "offers.header.text2" | translate }}
    </p>
    <button
      routerLink="/contact"
      routerLinkActive="active"
      class="contact"
      id="btn-con"
    >
      {{ "offers.header.button" | translate }} →
    </button>
  </div>
</section>
<app-offer
  offerTitle="offers.mdm.header"
  descHeaderHighlight="offers.mdm.highlight"
  descHeaderHighlight1="offers.mdm.header1"
  descHeader="offers.mdm.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc1"
  [descLogo1]="{
    src: 'assets/img/references/poczta.png',
    alt: 'Orange Polska',
    link: 'https://www.poczta-polska.pl'
  }"
  [descLogo2]="{
    src: 'assets/img/references/RCB.png',
    alt: 'RCB',
    link: 'https://www.gov.pl/web/rcb'
  }"
  [descLogo3]="{
    src: 'assets/img/references/MSWiA.png',
    alt: 'MSWiA',
    link: 'https://www.gov.pl/web/mswia'
  }"
  [descLogo4]="{
    src: 'assets/img/techstep.png',
    alt: 'Techstep',
    link: 'https://www.techstep.io/pl/'
  }"
  [descLogo5]="{
    src: 'assets/img/versim.png',
    alt: 'Versim',
    link: 'https://www.versim.pl'
  }"
  abilHeaderHighlight="offers.mdm.abilHeader"
  abilHeader="offers.mdm.abilHeaderHighlight"
  abilBold1="offers.mdm.abilBold1"
  abilText1="offers.mdm.abilText1"
  abilBold2="offers.mdm.abilBold2"
  abilText2="offers.mdm.abilText2"
  abilBold3="offers.mdm.abilBold3"
  abilText3="offers.mdm.abilText3"
  abilBold4="offers.mdm.abilBold4"
  abilText4="offers.mdm.abilText4"
  abilBold5="offers.mdm.abilBold5"
  abilText5="offers.mdm.abilText5"
  prosHeader="offers.mdm.prosHeader"
  prosBold1="offers.mdm.prosBold1"
  prosText1="offers.mdm.prosText1"
  prosBold2="offers.mdm.prosBold2"
  prosText2="offers.mdm.prosText2"
  prosBold3="offers.mdm.prosBold3"
  prosText3="offers.mdm.prosText3"
  prosBold4="offers.mdm.prosBold4"
  prosText4="offers.mdm.prosText4"
  howHeader="offers.mdm.howHeader"
  howBold1="offers.mdm.howBold1"
  howText1="offers.mdm.howText1"
  howBold2="offers.mdm.howBold2"
  howText2="offers.mdm.howText2"
  howBold3="offers.mdm.howBold3"
  howText3="offers.mdm.howText3"
  howBold4="offers.mdm.howBold4"
  howText4="offers.mdm.howText4"
  techHeader="offers.mdm.techHeader"
  techBold1="offers.mdm.techBold1"
  techText1="offers.mdm.techText1"
  techBold2="offers.mdm.techBold2"
  techText2="offers.mdm.techText2"
  techBold3="offers.mdm.techBold3"
  techText3="offers.mdm.techText3"
  techBold4="offers.mdm.techBold4"
  techText4="offers.mdm.techText4"
  forHeader="offers.mdm.forHeader"
  forText1="offers.mdm.forText1"
  forText2="offers.mdm.forText2"
  forText3="offers.mdm.forText3"
  forText4="offers.mdm.forText4"
  checkHeader="offers.mdm.checkHeader"
  checkBold1="offers.mdm.checkBold1"
  checkText1="offers.mdm.checkText1"
  checkLink1="https://www.techstep.io/pl/"
  checkBold2="offers.mdm.checkBold2"
  checkText2="offers.mdm.checkText2"
  checkLink2="https://support.famoc.com/pl/support/home"
></app-offer>
<app-offer
  offerTitle="offers.network.header"
  descHeaderHighlight="offers.network.highlight"
  descHeaderHighlight1="offers.network.header1"
  descHeader="offers.network.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc1"
  [descLogo1]="{
    src: 'assets/img/references/Orange.png',
    alt: 'Orange Polska',
    link: 'https://www.orange.pl'
  }"
  [descLogo4]="{
    src: 'assets/img/Infosim.png',
    alt: 'Infosim',
    link: 'https://www.infosim.net'
  }"
  abilHeaderHighlight="offers.network.abilHeader"
  abilHeader="offers.network.abilHeaderHighlight"
  abilBold1="offers.network.abilBold1"
  abilText1="offers.network.abilText1"
  abilBold2="offers.network.abilBold2"
  abilText2="offers.network.abilText2"
  abilBold3="offers.network.abilBold3"
  abilText3="offers.network.abilText3"
  abilBold4="offers.network.abilBold4"
  abilText4="offers.network.abilText4"
  prosHeader="offers.network.prosHeader"
  prosBold1="offers.network.prosBold1"
  prosText1="offers.network.prosText1"
  prosBold2="offers.network.prosBold2"
  prosText2="offers.network.prosText2"
  prosBold3="offers.network.prosBold3"
  prosText3="offers.network.prosText3"
  prosBold4="offers.network.prosBold4"
  prosText4="offers.network.prosText4"
  howHeader="offers.network.howHeader"
  howBold1="offers.network.howBold1"
  howText1="offers.network.howText1"
  howBold2="offers.network.howBold2"
  howText2="offers.network.howText2"
  howBold3="offers.network.howBold3"
  howText3="offers.network.howText3"
  howBold4="offers.network.howBold4"
  howText4="offers.network.howText4"
  techHeader="offers.network.techHeader"
  techBold1="offers.network.techBold1"
  techText1="offers.network.techText1"
  techBold2="offers.network.techBold2"
  techText2="offers.network.techText2"
  techBold3="offers.network.techBold3"
  techText3="offers.network.techText3"
  techBold4="offers.network.techBold4"
  techText4="offers.network.techText4"
  forHeader="offers.network.forHeader"
  forText1="offers.network.forText1"
  forText2="offers.network.forText2"
  forText3="offers.network.forText3"
  forBold1="offers.network.forBold1"
  forBold2="offers.network.forBold2"
  forBold3="offers.network.forBold3"
  forBold4="offers.network.forBold4"
  checkHeader="offers.network.checkHeader"
  checkBold1="offers.network.checkBold1"
  checkText1="offers.network.checkText1"
  checkLink1="https://www.infosim.net"
  checkBold2="offers.network.checkBold2"
  checkText2="offers.network.checkText2"
  checkLink2="https://www.infosim.net/stablenet/"
  descHeaderHighlightA="offers.network.highlightA"
  descHeaderHighlight1A="offers.network.header1A"
  descHeaderA="offers.network.descA"
  descText1A="offers.collapsible.desc"
  descText2A="offers.collapsible.desc1"
  [descLogo1A]="{
    src: 'assets/img/Omantel.png',
    alt: 'Omantel',
    link: 'https://www.omantel.om'
  }"
  [descLogo4A]="{
    src: 'assets/img/IBM.png',
    alt: 'IBM',
    link: 'https://www.ibm.com/us-en'
  }"
  abilHeaderHighlightA="offers.network.abilHeaderA"
  abilHeaderA="offers.network.abilHeaderHighlightA"
  abilBold1A="offers.network.abilBold1A"
  abilText1A="offers.network.abilText1A"
  abilBold2A="offers.network.abilBold2A"
  abilText2A="offers.network.abilText2A"
  abilBold3A="offers.network.abilBold3A"
  abilText3A="offers.network.abilText3A"
  abilBold4A="offers.network.abilBold4A"
  abilText4A="offers.network.abilText4A"
  prosHeaderA="offers.network.prosHeaderA"
  prosBold1A="offers.network.prosBold1A"
  prosText1A="offers.network.prosText1A"
  prosBold2A="offers.network.prosBold2A"
  prosText2A="offers.network.prosText2A"
  prosBold3A="offers.network.prosBold3A"
  prosText3A="offers.network.prosText3A"
  prosBold4A="offers.network.prosBold4A"
  prosText4A="offers.network.prosText4A"
  howHeaderA="offers.network.howHeaderA"
  howBold1A="offers.network.howBold1A"
  howText1A="offers.network.howText1A"
  howBold2A="offers.network.howBold2A"
  howText2A="offers.network.howText2A"
  howBold3A="offers.network.howBold3A"
  howText3A="offers.network.howText3A"
  howBold4A="offers.network.howBold4A"
  howText4A="offers.network.howText4A"
  techHeaderA="offers.network.techHeaderA"
  techBold1A="offers.network.techBold1A"
  techText1A="offers.network.techText1A"
  techBold2A="offers.network.techBold2A"
  techText2A="offers.network.techText2A"
  techBold3A="offers.network.techBold3A"
  techText3A="offers.network.techText3A"
  techBold4A="offers.network.techBold4A"
  techText4A="offers.network.techText4A"
  forHeaderA="offers.network.forHeaderA"
  forText1A="offers.network.forText1A"
  forText2A="offers.network.forText2A"
  forText3A="offers.network.forText3A"
  forBold1A="offers.network.forBold1A"
  forBold2A="offers.network.forBold2A"
  forBold3A="offers.network.forBold3A"
  forBold4A="offers.network.forBold4A"
  checkHeaderA="offers.network.checkHeader"
  checkBold1A="offers.network.checkBold1"
  checkText1A="offers.network.checkText1"
  checkLink1A="https://www.ibm.com/us-en"
  checkBold2A="offers.network.checkBold2"
  checkText2A="offers.network.checkText2"
  checkLink2A="https://www.ibm.com/docs/pl/netcoolomnibus/8.1.0?topic=overview-introduction-tivoli-netcoolomnibus"
></app-offer>
<app-offer
  offerTitle="offers.security.header"
  descHeaderHighlight="offers.security.highlight"
  descHeaderHighlight1="offers.security.header1"
  descHeader="offers.security.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc1"
  [descLogo4]="{
    src: 'assets/img/techstep.png',
    alt: 'Techstep',
    link: 'https://www.techstep.io/pl/'
  }"
  [descLogo5]="{
    src: 'assets/img/Pradeo.jpeg',
    alt: 'Pradeo',
    link: 'https://pradeo.com/en/'
  }"
  abilHeaderHighlight="offers.security.abilHeader"
  abilHeader="offers.security.abilHeaderHighlight"
  abilBold1="offers.security.abilBold1"
  abilText1="offers.security.abilText1"
  abilBold2="offers.security.abilBold2"
  abilText2="offers.security.abilText2"
  abilBold3="offers.security.abilBold3"
  abilText3="offers.security.abilText3"
  prosHeader="offers.security.prosHeader"
  prosBold1="offers.security.prosBold1"
  prosText1="offers.security.prosText1"
  prosBold2="offers.security.prosBold2"
  prosText2="offers.security.prosText2"
  prosBold3="offers.security.prosBold3"
  prosText3="offers.security.prosText3"
  howHeader="offers.security.howHeader"
  howBold1="offers.security.howBold1"
  howText1="offers.security.howText1"
  howBold2="offers.security.howBold2"
  howText2="offers.security.howText2"
  howBold3="offers.security.howBold3"
  howText3="offers.security.howText3"
  howBold4="offers.security.howBold4"
  howText4="offers.security.howText4"
  techHeader="offers.security.techHeader"
  techBold1="offers.security.techBold1"
  techText1="offers.security.techText1"
  techBold2="offers.security.techBold2"
  techText2="offers.security.techText2"
  forHeader="offers.security.forHeader"
  forBold1="offers.security.forBold1"
  forBold2="offers.security.forBold2"
  forBold3="offers.security.forBold3"
  forText1="offers.security.forText1"
  forText2="offers.security.forText2"
  forText3="offers.security.forText3"
  checkHeader="offers.security.checkHeader"
  checkBold1="offers.security.checkBold1"
  checkText1="offers.security.checkText1"
  checkLink1="https://pradeo.com/en"
  checkBold2="offers.security.checkBold2"
  checkText2="offers.security.checkText2"
  checkLink2="https://pradeo.com/en/form/mobile-threat-defense/"
  descHeaderHighlightA="offers.security.highlightA"
  descHeaderHighlight1A="offers.security.header1A"
  descHeaderA="offers.security.descA"
  descText1A="offers.collapsible.desc"
  descText2A="offers.collapsible.desc1"
  abilHeaderHighlightA="offers.security.abilHeaderA"
  abilHeaderA="offers.security.abilHeaderHighlightA"
  abilBold1A="offers.security.abilBold1A"
  abilText1A="offers.security.abilText1A"
  abilBold2A="offers.security.abilBold2A"
  abilText2A="offers.security.abilText2A"
  prosHeaderA="offers.security.prosHeaderA"
  prosBold1A="offers.security.prosBold1A"
  prosText1A="offers.security.prosText1A"
  prosBold2A="offers.security.prosBold2A"
  prosText2A="offers.security.prosText2A"
  prosBold3A="offers.security.prosBold3A"
  prosText3A="offers.security.prosText3A"
  howHeaderA="offers.security.howHeaderA"
  howBold1A="offers.security.howBold1A"
  howText1A="offers.security.howText1A"
  howBold2A="offers.security.howBold2A"
  howText2A="offers.security.howText2A"
  howBold3A="offers.security.howBold3A"
  howText3A="offers.security.howText3A"
  howBold4A="offers.security.howBold4A"
  howText4A="offers.security.howText4A"
  forHeaderA="offers.security.forHeaderA"
  forText1A="offers.security.forText1A"
  forText2A="offers.security.forText2A"
  forText3A="offers.security.forText3A"
  forBold1A="offers.security.forBold1A"
  forBold2A="offers.security.forBold2A"
  forBold3A="offers.security.forBold3A"
  forBold4A="offers.security.forBold4A"
  checkHeaderA="offers.security.checkHeaderA"
  checkBold1A="offers.security.checkBold1A"
  checkText1A="offers.security.checkText1A"
  checkLink1A="https://sentyron.com"
  checkBold2A="offers.security.checkBold2A"
  checkText2A="offers.security.checkText2A"
  checkLink2A="https://sentyron.com/solutions/sentyron-datadiode-andean-1g/"
></app-offer>
<app-offer
  offerTitle="offers.incident.header"
  descHeaderHighlight="offers.incident.highlight"
  descHeaderHighlight1="offers.incident.header1"
  descHeader="offers.incident.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc1"
  [descLogo4]="{
    src: 'assets/img/FRQ.png',
    alt: 'Frequentis',
    link: 'https://www.frequentis.com'
  }"
  abilHeaderHighlight="offers.incident.abilHeader"
  abilHeader="offers.incident.abilHeaderHighlight"
  abilBold1="offers.incident.abilBold1"
  abilText1="offers.incident.abilText1"
  abilBold2="offers.incident.abilBold2"
  abilText2="offers.incident.abilText2"
  abilBold3="offers.incident.abilBold3"
  abilText3="offers.incident.abilText3"
  abilBold4="offers.incident.abilBold4"
  abilText4="offers.incident.abilText4"
  prosHeader="offers.incident.prosHeader"
  prosBold1="offers.incident.prosBold1"
  prosText1="offers.incident.prosText1"
  prosBold2="offers.incident.prosBold2"
  prosText2="offers.incident.prosText2"
  prosBold3="offers.incident.prosBold3"
  prosText3="offers.incident.prosText3"
  howHeader="offers.incident.howHeader"
  howBold1="offers.incident.howBold1"
  howText1="offers.incident.howText1"
  howBold2="offers.incident.howBold2"
  howText2="offers.incident.howText2"
  howBold3="offers.incident.howBold3"
  howText3="offers.incident.howText3"
  howBold4="offers.incident.howBold4"
  howText4="offers.incident.howText4"
  techHeader="offers.incident.techHeader"
  techBold1="offers.incident.techBold1"
  techText1="offers.incident.techText1"
  techBold2="offers.incident.techBold2"
  techText2="offers.incident.techText2"
  techBold3="offers.incident.techBold3"
  techText3="offers.incident.techText3"
  techBold4="offers.incident.techBold4"
  techText4="offers.incident.techText4"
  forHeader="offers.incident.forHeader"
  forSubheader="offers.incident.forSubheader"
  forBold1="offers.incident.forBold1"
  forText1="offers.incident.forText1"
  forBold2="offers.incident.forBold2"
  forText2="offers.incident.forText2"
  forBold3="offers.incident.forBold3"
  forText3="offers.incident.forText3"
  forBold4="offers.incident.forBold4"
  forText4="offers.incident.forText4"
  checkHeader="offers.incident.checkHeader"
  checkBold1="offers.incident.checkBold1"
  checkText1="offers.incident.checkText1"
  checkLink1="https://www.frequentis.com"
  checkBold2="offers.incident.checkBold2"
  checkText2="offers.incident.checkText2"
  checkLink2="https://www.frequentis.com/sites/default/files/support/2020-10/Frequentis_MAR_solution-brief_MarTRX-ICM.pdf"
></app-offer>
<app-offer
  offerTitle="offers.audit.header"
  descHeaderHighlight="offers.audit.highlight"
  descHeaderHighlight1="offers.audit.header1"
  descHeader="offers.audit.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc"
  [descLogo1]="{
    src: 'assets/img/references/Chipolbrok.png',
    alt: 'Chipolbrok',
    link: 'https://chipolbrok.com.pl'
  }"
  abilHeaderHighlight="offers.audit.abilHeader"
  abilHeader="offers.audit.abilHeaderHighlight"
  abilBold1="offers.audit.abilBold1"
  abilText1="offers.audit.abilText1"
  abilBold2="offers.audit.abilBold2"
  abilText2="offers.audit.abilText2"
  abilBold3="offers.audit.abilBold3"
  abilText3="offers.audit.abilText3"
  abilBold4="offers.audit.abilBold4"
  abilText4="offers.audit.abilText4"
  abilBold5="offers.audit.abilBold5"
  abilText5="offers.audit.abilText5"
  prosHeader="offers.audit.prosHeader"
  prosBold1="offers.audit.prosBold1"
  prosText1="offers.audit.prosText1"
  prosBold2="offers.audit.prosBold2"
  prosText2="offers.audit.prosText2"
  prosBold3="offers.audit.prosBold3"
  prosText3="offers.audit.prosText3"
  howHeader="offers.audit.howHeader"
  howBold1="offers.audit.howBold1"
  howText1="offers.audit.howText1"
  howBold2="offers.audit.howBold2"
  howText2="offers.audit.howText2"
  howBold3="offers.audit.howBold3"
  howText3="offers.audit.howText3"
  howBold4="offers.audit.howBold4"
  howText4="offers.audit.howText4"
  forHeader="offers.audit.forHeader"
  forSubheader="offers.audit.forSubheader"
  forBold1="offers.audit.forBold1"
  forText1="offers.audit.forText1"
  forBold2="offers.audit.forBold2"
  forText2="offers.audit.forText2"
  forBold3="offers.audit.forBold3"
  forText3="offers.audit.forText3"
  checkHeader="offers.audit.checkHeader"
  checkBold1="offers.audit.checkBold1"
  checkText1="offers.audit.checkText1"
  checkLink1="https://www.biznes.gov.pl/pl/portal/005120"
  descHeaderHighlightA="offers.audit.highlightA"
  descHeaderHighlight1A="offers.audit.header1A"
  descHeaderA="offers.audit.descA"
  descText1A="offers.collapsible.desc"
  descText2A="offers.collapsible.desc1"
  [descLogo1]="{
    src: 'assets/img/references/prs.png',
    alt: 'Państwowy Rejestr Statków',
    link: 'https://prs.pl'
  }"
  abilHeaderHighlightA="offers.audit.abilHeaderA"
  abilHeaderA="offers.audit.abilHeaderHighlightA"
  abilBold1A="offers.audit.abilBold1A"
  abilText1A="offers.audit.abilText1A"
  abilBold2A="offers.audit.abilBold2A"
  abilText2A="offers.audit.abilText2A"
  abilBold3A="offers.audit.abilBold3A"
  abilText3A="offers.audit.abilText3A"
  abilBold4A="offers.audit.abilBold4A"
  abilText4A="offers.audit.abilText4A"
  abilBold5A="offers.audit.abilBold5A"
  abilText5A="offers.audit.abilText5A"
  prosHeaderA="offers.audit.prosHeaderA"
  prosBold1A="offers.audit.prosBold1A"
  prosText1A="offers.audit.prosText1A"
  prosBold2A="offers.audit.prosBold2A"
  prosText2A="offers.audit.prosText2A"
  prosBold3A="offers.audit.prosBold3A"
  prosText3A="offers.audit.prosText3A"
  howBold1A="offers.audit.howBold1A"
  howText1A="offers.audit.howText1A"
  howBold2A="offers.audit.howBold2A"
  howText2A="offers.audit.howText2A"
  howBold3A="offers.audit.howBold3A"
  howText3A="offers.audit.howText3A"
  howBold4A="offers.audit.howBold4A"
  howText4A="offers.audit.howText4A"
  checkHeaderA="offers.audit.checkHeaderA"
  checkBold1A="offers.audit.checkBold1A"
  checkText1A="offers.audit.checkText1A"
  checkLink1A="https://uodo.gov.pl/pl/404/224"
  descHeaderHighlightB="offers.audit.highlightB"
  descHeaderHighlight1B="offers.audit.header1B"
  descHeaderB="offers.audit.descB"
  descText1B="offers.collapsible.desc"
  descText2B="offers.collapsible.desc1"
  abilHeaderHighlightB="offers.audit.abilHeaderB"
  abilHeaderB="offers.audit.abilHeaderHighlightB"
  abilBold1B="offers.audit.abilBold1B"
  abilText1B="offers.audit.abilText1B"
  abilBold2B="offers.audit.abilBold2B"
  abilText2B="offers.audit.abilText2B"
  abilBold3B="offers.audit.abilBold3B"
  abilText3B="offers.audit.abilText3B"
  abilBold4B="offers.audit.abilBold4B"
  abilText4B="offers.audit.abilText4B"
  abilBold5B="offers.audit.abilBold5B"
  abilText5B="offers.audit.abilText5B"
  prosHeaderB="offers.audit.prosHeaderB"
  prosBold1B="offers.audit.prosBold1B"
  prosText1B="offers.audit.prosText1B"
  prosBold2B="offers.audit.prosBold2B"
  prosText2B="offers.audit.prosText2B"
  prosBold3B="offers.audit.prosBold3B"
  prosText3B="offers.audit.prosText3B"
  howBold1B="offers.audit.howBold1B"
  howText1B="offers.audit.howText1B"
  howBold2B="offers.audit.howBold2B"
  howText2B="offers.audit.howText2B"
  howBold3B="offers.audit.howBold3B"
  howText3B="offers.audit.howText3B"
  howBold4B="offers.audit.howBold4B"
  howText4B="offers.audit.howText4B"
></app-offer>
<app-offer
  offerTitle="offers.sourcing.header"
  descHeaderHighlight="offers.sourcing.highlight"
  descHeaderHighlight1="offers.sourcing.header1"
  descHeader="offers.sourcing.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc1"
  abilHeaderHighlight="offers.sourcing.abilHeader"
  abilHeader="offers.sourcing.abilHeaderHighlight"
  abilBold1="offers.sourcing.abilBold1"
  abilText1="offers.sourcing.abilText1"
  abilBold2="offers.sourcing.abilBold2"
  abilText2="offers.sourcing.abilText2"
  abilBold3="offers.sourcing.abilBold3"
  abilText3="offers.sourcing.abilText3"
  prosHeader="offers.sourcing.prosHeader"
  prosBold1="offers.sourcing.prosBold1"
  prosText1="offers.sourcing.prosText1"
  prosBold2="offers.sourcing.prosBold2"
  prosText2="offers.sourcing.prosText2"
  prosBold3="offers.sourcing.prosBold3"
  prosText3="offers.sourcing.prosText3"
  howHeader="offers.sourcing.howHeader"
  howBold1="offers.sourcing.howBold1"
  howText1="offers.sourcing.howText1"
  howBold2="offers.sourcing.howBold2"
  howText2="offers.sourcing.howText2"
  howBold3="offers.sourcing.howBold3"
  howText3="offers.sourcing.howText3"
  howBold4="offers.sourcing.howBold4"
  howText4="offers.sourcing.howText4"
  descHeaderHighlightA="offers.audit.highlightB"
  descHeaderHighlight1A="offers.audit.header1B"
  descHeaderA="offers.audit.descB"
  descText1A="offers.collapsible.desc"
  descText2A="offers.collapsible.desc1"
  abilHeaderHighlightA="offers.audit.abilHeaderB"
  abilHeaderA="offers.audit.abilHeaderHighlightB"
  abilBold1A="offers.audit.abilBold1B"
  abilText1A="offers.audit.abilText1B"
  abilBold2A="offers.audit.abilBold2B"
  abilText2A="offers.audit.abilText2B"
  abilBold3A="offers.audit.abilBold3B"
  abilText3A="offers.audit.abilText3B"
  abilBold4A="offers.audit.abilBold4B"
  abilText4A="offers.audit.abilText4B"
  abilBold5A="offers.audit.abilBold5B"
  abilText5A="offers.audit.abilText5B"
  prosHeaderA="offers.audit.prosHeaderB"
  prosBold1A="offers.audit.prosBold1B"
  prosText1A="offers.audit.prosText1B"
  prosBold2A="offers.audit.prosBold2B"
  prosText2A="offers.audit.prosText2B"
  prosBold3A="offers.audit.prosBold3B"
  prosText3A="offers.audit.prosText3B"
  howBold1A="offers.audit.howBold1B"
  howText1A="offers.audit.howText1B"
  howBold2A="offers.audit.howBold2B"
  howText2A="offers.audit.howText2B"
  howBold3A="offers.audit.howBold3B"
  howText3A="offers.audit.howText3B"
  howBold4A="offers.audit.howBold4B"
  howText4A="offers.audit.howText4B"
></app-offer>
<app-offer
  offerTitle="offers.iplabel.header"
  descHeaderHighlight="offers.iplabel.highlight"
  descHeaderHighlight1="offers.iplabel.header1"
  descHeader="offers.iplabel.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc1"
  [descLogo1]="{
    src: 'assets/img/references/Orange.png',
    alt: 'Orange Polska',
    link: 'https://www.orange.pl'
  }"
  [descLogo4]="{
    src: 'assets/img/Ekara.jpeg',
    alt: 'Ekara',
    link: 'https://ip-label.com'
  }"
  abilHeaderHighlight="offers.iplabel.abilHeader"
  abilHeader="offers.iplabel.abilHeaderHighlight"
  abilBold1="offers.iplabel.abilBold1"
  abilText1="offers.iplabel.abilText1"
  abilBold2="offers.iplabel.abilBold2"
  abilText2="offers.iplabel.abilText2"
  abilBold3="offers.iplabel.abilBold3"
  abilText3="offers.iplabel.abilText3"
  abilBold4="offers.iplabel.abilBold4"
  abilText4="offers.iplabel.abilText4"
  prosHeader="offers.iplabel.prosHeader"
  prosBold1="offers.iplabel.prosBold1"
  prosText1="offers.iplabel.prosText1"
  prosBold2="offers.iplabel.prosBold2"
  prosText2="offers.iplabel.prosText2"
  prosBold3="offers.iplabel.prosBold3"
  prosText3="offers.iplabel.prosText3"
  prosBold4="offers.iplabel.prosBold4"
  prosText4="offers.iplabel.prosText4"
  howHeader="offers.iplabel.howHeader"
  howBold1="offers.iplabel.howBold1"
  howText1="offers.iplabel.howText1"
  howBold2="offers.iplabel.howBold2"
  howText2="offers.iplabel.howText2"
  howBold3="offers.iplabel.howBold3"
  howText3="offers.iplabel.howText3"
  howBold4="offers.iplabel.howBold4"
  howText4="offers.iplabel.howText4"
  techHeader="offers.iplabel.techHeader"
  techBold1="offers.iplabel.techBold1"
  techText1="offers.iplabel.techText1"
  techBold2="offers.iplabel.techBold2"
  techText2="offers.iplabel.techText2"
  techBold3="offers.iplabel.techBold3"
  techText3="offers.iplabel.techText3"
  forHeader="offers.iplabel.forHeader"
  forSubheader="offers.iplabel.forSubheader"
  checkHeader="offers.iplabel.checkHeader"
  checkBold1="offers.iplabel.checkBold1"
  checkText1="offers.iplabel.checkText1"
  checkLink1="https://ip-label.com"
></app-offer>
<app-offer
  offerTitle="offers.osp.header"
  descHeaderHighlight="offers.osp.highlight"
  descHeaderHighlight1="offers.osp.header1"
  descHeader="offers.osp.desc"
  descText1="offers.collapsible.desc"
  descText2="offers.collapsible.desc1"
  abilHeaderHighlight="offers.osp.abilHeader"
  abilHeader="offers.osp.abilHeaderHighlight"
  abilBold1="offers.osp.abilBold1"
  abilText1="offers.osp.abilText1"
  abilBold2="offers.osp.abilBold2"
  abilText2="offers.osp.abilText2"
  abilBold3="offers.osp.abilBold3"
  abilText3="offers.osp.abilText3"
  abilBold4="offers.osp.abilBold4"
  abilText4="offers.osp.abilText4"
  abilBold5="offers.osp.abilBold5"
  abilText5="offers.osp.abilText5"
  prosHeader="offers.osp.prosHeader"
  prosBold1="offers.osp.prosBold1"
  prosText1="offers.osp.prosText1"
  prosBold2="offers.osp.prosBold2"
  prosText2="offers.osp.prosText2"
  prosBold3="offers.osp.prosBold3"
  prosText3="offers.osp.prosText3"
  prosBold4="offers.osp.prosBold4"
  prosText4="offers.osp.prosText4"
  prosBold5="offers.osp.prosBold5"
  prosText5="offers.osp.prosText5"
  techHeader="offers.osp.techHeader"
  techBold1="offers.osp.techBold1"
  techText1="offers.osp.techText1"
  techBold2="offers.osp.techBold2"
  techText2="offers.osp.techText2"
  techBold3="offers.osp.techBold3"
  techText3="offers.osp.techText3"
  techBold4="offers.osp.techBold4"
  techText4="offers.osp.techText4"
  forHeader="offers.osp.forHeader"
  forText1="offers.osp.forText1"
  forText2="offers.osp.forText2"
  forText3="offers.osp.forText3"
  checkHeader="offers.osp.checkHeader"
  checkBold1="offers.osp.checkBold1"
  checkText1="offers.osp.checkText1"
  checkLink1="assets/pdf/OSP.pdf"
></app-offer>
